import { useContext, useEffect, useState } from "react";
import { UserContext } from "../../../utils/UserContext";

const LoadingScreen = ({ text }) => {
  const [dots, setDots] = useState(".");
  const { user } = useContext(UserContext);
  const { logo, storeName } = user || {};

  useEffect(() => {
    const interval = setInterval(() => {
      setDots((prev) => {
        if (prev.length >= 3) return ".";
        return prev + ".";
      });
    }, 500); // speed control

    return () => clearInterval(interval);
  }, []);

  return (
    <div className="content">
      <div className="splashScreen">
        <div className="loadingContainer">
          <div className="loadingBox">
            <img
              src={logo || `${process.env.PUBLIC_URL}/img/logo.png`}
              className="splashLogo"
            />

            <div className="loadingBarContainer">
              Loading{dots}
            </div>

            <div className="loadingCircle">
              <div className="circleOuter"></div>
              <div className="circleLoader"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoadingScreen;
